<template>
  <div space-y-4 v-if="article">
    <h2 text-2xl font-semibold text-stone-500 v-if="showTitle">About {{ title }}</h2>
    <img
      v-if="article.originalimage"
      :src="article.originalimage.source"
      :width="article.originalimage.width"
      :height="article.originalimage.height"
      loading="lazy"
      alt=""
    />
    <div prose v-html="article.extract_html" />
    <p>
      <Button
        color="light-stone"
        :href="`https://en.wikipedia.org/wiki/${props.slug}`"
        icon="i-material-symbols-arrow-outward-rounded"
        target="_blank"
        >View on Wikipedia
      </Button>
    </p>
  </div>
</template>
<script setup>
import { decode } from "wiki-article-name-encoding";

const props = defineProps({
  slug: {
    type: String,
    required: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});
const title = computed(() => decode(props.slug));
const { data: article, error } = await useLazyFetch(() => props.slug, {
  baseURL: "https://en.wikipedia.org/api/rest_v1/page/summary/",
});
</script>
